
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';


import { hooks } from '../hooks';
import { actions } from '../store/actions';
import { components } from '../components';

import green from '../assets/images/veg.png';
import red from '../assets/images/non-veg.png';

import settings from '../assets/images/settings.png';
import menu from '../assets/images/menu.png';
import close from '../assets/images/close.png';

import food from '../assets/images/food-placeholder.jpg'
import Config from '../configs/config.json';
import thumbnail from '../assets/images/fsr-placeholder.png'

import { FaTimes } from 'react-icons/fa';
import { FiArrowRightCircle } from 'react-icons/fi'
import { FiMinus, FiPlus } from "react-icons/fi";
import { getCollection, getCollectionById, getCollectionByRestaurant } from '../services';
import { v4 as uuidv4 } from 'uuid'
import { BeatLoader, PropagateLoader } from 'react-spinners'

import { db } from '../configs/firebaseConfig'
import { getDocs, getDoc, doc, collection, where, query } from 'firebase/firestore'

import Gallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

interface Menu {
  id: string;
  name: string;
}

interface PlatformFee {
  value: string;
  currency: string;
};

interface Cart {
  id: number | string;
  name: string;
  full_price: string;
  half_price: string;
  quarter_price: string;
  quantity: number;
  portion: string;
  is_full_portion: string;
  is_half_portion: string;
  is_quarter_portion: string;
  estimated_time: string;
  veg_type: string;
}

interface Items {
  id: string;
  name: string;
  description: string;
  full_price: string;
  half_price: string;
  quarter_price: string;
  images: string[];
  estimated_time: string;
  is_full_portion: string;
  is_half_portion: string;
  is_quarter_portion: string;
  veg_type: string;
  status: number | string;
}

export const Shop: React.FC = () => {

  const dispatch = hooks.useDispatch();

  const nav = useNavigate()
  const location = useLocation()
  const { id }: any = useParams();
  const [itemCount, setItemCount] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeModal, setActiveModal] = useState<string | null>(null)
  const [selectedPortion, setSelectedPortion] = useState<string>('full')
  const [isMenuModalOpen, setIsMenuModalOpen] = useState(false)
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [menus, setMenus] = useState<Menu[]>([]);
  const [allItems, setAllItems] = useState<Items[]>([]);
  const [items, setItems] = useState<Items[]>([]);
  const [currentSection, setCurrentSection] = useState(0)

  const [validId, setValidId] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [isRestaurant, setIsRestaurant] = useState(false);


  const [selectedItem, setSelectedItem] = useState<Items | null>(null);
  const [cart, setCart] = useState<Cart[]>([]);
  const [isGreenToggled, setIsGreenToggled] = useState(false)
  const [isRedToggled, setIsRedToggled] = useState(false)

  const [filteredItems, setFilteredItems] = useState<Items[]>([]);

  const [restaurantId, setRestaurantId] = useState<string | null>(null);
  const [taxName, setTaxName] = useState('');
  const [currencySymbol, setCurrencySymbol] = useState<string | null>(null);
  const [currency, setCurrency] = useState<string | null>(null)
  const [platformFee, setPlatformFee] = useState<PlatformFee | null>(null);
  const [walletBalance, setWalletBalance] = useState<number | null>(null);
  const [serviceAvailable, setServiceAvailable] = useState<boolean>(true);

  const galleryImages = selectedItem && selectedItem.images && selectedItem.images.length > 0
    ? selectedItem.images.map((image) => ({
      original: `${Config.MEDIA_URL}${image}?alt=media`,
      thumbnail: `${Config.MEDIA_URL}${image}?alt=media`,
      originalHeight: 300
    }))
    : [
      {
        original: food,
        thumbnail: thumbnail,
        originalHeight: 300
      },
    ]

  const handleThumbnailClick = (image: string) => {
    const images = selectedItem?.images || [];
    const newSelectedItem: Items = {
      id: selectedItem?.id ?? '',
      name: selectedItem?.name ?? '',
      status: selectedItem?.status ?? '',
      description: selectedItem?.description ?? '',
      full_price: selectedItem?.full_price ?? '',
      half_price: selectedItem?.half_price ?? '',
      quarter_price: selectedItem?.quarter_price ?? '',
      estimated_time: selectedItem?.estimated_time ?? '',
      is_full_portion: selectedItem?.is_full_portion ?? '',
      is_half_portion: selectedItem?.is_half_portion ?? '',
      is_quarter_portion: selectedItem?.is_quarter_portion ?? '',
      veg_type: selectedItem?.veg_type ?? '',


      images: [image, ...images.filter((img) => img !== image)],
    };

    setSelectedItem(newSelectedItem);
  };

  useEffect(() => {
    getCollection("configurations")
      .then(
        (data: { id: string; currency?: { symbol?: string }; platformFee?: { value?: string; currency?: string } }[]) => {
          if (data?.length > 0) {
            const currencyConfig = data.find((item) => item.currency?.symbol);
            if (currencyConfig?.currency?.symbol) {
              setCurrencySymbol(currencyConfig.currency.symbol);
            } else {
              setCurrencySymbol(null);
            }

            const feeConfig = data.find((item) => item.platformFee?.value && item.platformFee?.currency);
            if (feeConfig?.platformFee) {
              const { value, currency } = feeConfig.platformFee;

              if (typeof value === 'string' && typeof currency === 'string') {
                setPlatformFee({ value, currency });
                // console.log("fee:", feeConfig?.platformFee)
              } else {
                setPlatformFee(null);
              }
            } else {
              setCurrencySymbol(null);
              setPlatformFee(null);
            }
          }
        }
      ).catch((error) => {
        console.error("Error fetching configurations:", error);
        setCurrencySymbol(null);
        setPlatformFee(null);
      });
  }, []);

  hooks.useThemeColor('#fff');

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(actions.setColor('#fff'));
  }, []);


  const getMenuItems = async (categoryMap: any) => {
    setIsFetching(true);

    const collectionRef = collection(db, "items");

    const queries = Object.keys(categoryMap).map((categoryId) => {
      const baseQuery = query(collectionRef, where("category", "==", categoryId), where("status", "==", 1));

      if (categoryMap[categoryId].length > 0) {
        return query(baseQuery, where("subCategory", "in", categoryMap[categoryId]));
      }

      return baseQuery;
    });

    try {
      // Execute all queries in parallel
      const querySnapshots = await Promise.all(queries.map((q) => getDocs(q)));

      // Combine documents from all queries
      const documents: Items[] = querySnapshots.flatMap((snapshot) =>
        snapshot.docs.map((doc) => {
          const data = doc.data() as Items;
          return { ...data, id: doc.id };
        })
      );

      setAllItems(documents);
    } catch (error) {
      console.error("Error fetching menu items:", error);
    } finally {
      setIsFetching(false);
    }
  };

  const getSessionId = () => {
    let sessionId = localStorage.getItem('sessionId');
    if (!sessionId) {
      sessionId = uuidv4();
      localStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  }

  const getActiveOrder = async (tableId: any) => {
    const sessionId = getSessionId();
    const q = query(
      collection(db, 'orders'),
      where('qrId', '==', tableId),
      // where('sessionId', '==', sessionId),
      where('orderStatus', 'in', [0, 1])
    );

    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      return snapshot.docs[0]; // Active order found
    }
    return null;
  };

  useEffect(() => {
    if (validId) {

      const fromOrderDetails = localStorage.getItem('fromOrderDetails') === 'true';

      const existingToken = localStorage.getItem('token')
      if (existingToken && existingToken !== validId) {
        localStorage.clear()
      }

      // FETCH TABLE
      setIsLoading(true)
      getCollectionById('partnerqrs', validId).then((data: any) => {
        if (data) {
          setIsValid(true)
          // FETCH RESTAURANT
          getCollectionById('restaurants', data.restaurantId).then(async (result: any) => {

            if (result) {

              const res = result
              delete res.password

              localStorage.setItem('table', JSON.stringify(data))
              localStorage.setItem('restaurant', JSON.stringify(res))
              localStorage.setItem('token', validId)

              const order = await getActiveOrder(validId)

              // if (order && !fromOrderDetails) {
              //   nav('/order-details')
              //   return false
              // }

              setRestaurantId(res.id);
              setIsRestaurant(true)

              if (res.currency && res.currency.symbol) {
                setCurrency(res.currency.symbol)
              }
            } else {
              setIsRestaurant(false)
            }

            setTimeout(() => {
              setIsLoading(false)
            }, 500)
          });
        } else {
          setIsLoading(false)
          setIsValid(false)
        }
      });
    }
  }, [validId]);

  useEffect(() => {
    const restaurant = localStorage.getItem('restaurant')
    const res = restaurant ? JSON.parse(restaurant) : null

    if (res?.taxName) {
      setTaxName(res.taxName)
    }
    if (typeof res?.walletBalance === 'number') {
      setWalletBalance(res.walletBalance)
      // console.log("Shop balance:", res.walletBalance)
    } else {
      setWalletBalance(null)
    }
  }, [])

  useEffect(() => {
    if (id) {
      setValidId(id);
    } else {
      const token = localStorage.getItem('token');
      if (token && token !== "") {
        setValidId(token);
      }
    }
  }, [id]);

  useEffect(() => {

    // const restaurant = localStorage.getItem('restaurant');
    // const res = restaurant ? JSON.parse(restaurant) : null;

    if (restaurantId && serviceAvailable) {
      // GET MENUS
      getCollectionByRestaurant('menus', restaurantId).then((data: any) => {
        if (data && data.length > 0) {
          setMenus(data)
          const isSuggested = location.state?.selectedOptions ? true : false
          const existing = data.findIndex((obj: any) => obj.name === (isSuggested ? "Suggested" : "Main Course"))
          setCurrentSection(existing >= 0 ? existing : 0)
        } else {
          setMenus([])
          setCurrentSection(0)
        }
      })

      // GET MENU ITEMS
      setIsLoading(true)

      if (location.state?.selectedOptions) {
        getMenuItems(location.state?.selectedOptions)
      } else {
        getCollectionByRestaurant('items', restaurantId).then((data: any) => {
          setIsLoading(false)

          if (data && data.length > 0) {
            const filteredItems = data.filter((item: Items) => item.status === 1)
            setAllItems(filteredItems)
            // console.log("filtered items:", filteredItems)
          } else {
            setAllItems([])
          }
        })
      }
    } else {

      setMenus([])
      setAllItems([])
      setCurrentSection(0)
    }
  }, [restaurantId, serviceAvailable])


  useEffect(() => {
    if (allItems.length && menus.length && menus[currentSection]) {
      const filtered = allItems.filter((obj: any) => obj.type === menus[currentSection].id)
      setItems(filtered)
    } else {
      setItems([])
    }
  }, [allItems, currentSection, menus])

  useEffect(() => {
    if (items.length) {
      const filtered = items.filter((item: any) => {
        if (isGreenToggled && isRedToggled) {
          return item.veg_type === 'Veg' || item.veg_type === 'Non Veg'
        } else if (isGreenToggled) {
          return item.veg_type === 'Veg'
        } else if (isRedToggled) {
          return item.veg_type === 'Non Veg'
        }
        return true
      })

      setFilteredItems(filtered)
    } else {
      setFilteredItems([])
    }
  }, [isGreenToggled, isRedToggled, items])

  useEffect(() => {
    if (walletBalance != null && platformFee?.value) {
      const fee = parseFloat(platformFee.value);
      setServiceAvailable(walletBalance > fee);
    }
  }, [walletBalance, platformFee]);

  const openModal = (modalName: string) => {
    setIsModalOpen(true)
    setActiveModal(modalName)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setActiveModal(null)
    setSelectedItem(null)
  }

  const handleMenuClick = () => {
    setIsMenuModalOpen(true)
  }

  const handleMenuClose = () => {
    setIsMenuModalOpen(false)
  }

  const closeDetailModal = () => {
    setDetailModalOpen(false)
    setActiveModal(null)
  }

  const handleDetail = (data: any) => {
    setDetailModalOpen(true)
    setActiveModal('detail')
    setSelectedItem(data)
  }

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showBurger={true}
        showButton={true}
        showSwitch={true}
        headerStyle={{
          backgroundColor: 'transparent',
        }}
        setIsGreenToggled={setIsGreenToggled}
        setIsRedToggled={setIsRedToggled}
      />
    );
  };

  useEffect(() => {
    const storedCart = localStorage.getItem('cart')
    if (storedCart) {
      try {
        const parsedCart = JSON.parse(storedCart)
        if (Array.isArray(parsedCart)) {
          setCart(parsedCart)
        } else {
          setCart([])
          localStorage.removeItem('cart')
        }
      } catch (error) {
        console.error("Failed to parse cart from localStorage:", error)
        setCart([])
      }
    } else {
      setCart([])
    }
  }, [])

  useEffect(() => {
    if (cart && cart.length > 0) {
      const sum = cart.reduce((accumulator, current) => accumulator + current.quantity, 0)
      setItemCount(sum)
    } else {
      setItemCount(0)
    }
  }, [cart])

  const handleAddCart = () => {
    if (!selectedItem) {
      closeModal()
      return
    }

    const data = [...cart]

    data.push({
      ...selectedItem,
      quantity: 1,
      portion: selectedPortion || 'full',
    })

    setCart(data)
    localStorage.setItem('cart', JSON.stringify(data))
    closeModal()
  }

  const handleItemCountChange = (item: any, action: 'increment' | 'decrement') => {
    if (item && action) {
      setCart((prevData: any) => {
        const existingIndex = prevData.findIndex((obj: any) => obj.id === item.id);
        let updatedCart = [];

        if (existingIndex !== -1) {
          updatedCart = prevData.map((cartItem: any, index: number) => {
            if (index === existingIndex) {
              const updatedQuantity = (action === 'increment')
                ? cartItem.quantity + 1
                : (action === 'decrement')
                  ? cartItem.quantity - 1
                  : cartItem.quantity;

              return updatedQuantity > 0 ? { ...cartItem, quantity: updatedQuantity } : null;
            }
            return cartItem;
          }).filter((cartItem: any) => cartItem !== null);
        } else {
          let portion = 'full';

          if (item.is_full_portion && item.full_price) {
            portion = 'full';
          } else if (item.is_half_portion && item.half_price) {
            portion = 'half';
          } else if (item.is_quarter_portion && item.quarter_price) {
            portion = 'quarter';
          }

          updatedCart = [
            ...prevData,
            {
              id: item?.id,
              name: item?.name,
              full_price: item?.full_price,
              is_full_portion: item?.is_full_portion,
              half_price: item?.half_price,
              is_half_portion: item?.is_half_portion,
              quarter_price: item?.quarter_price,
              is_quarter_portion: item?.is_quarter_portion,
              portion: portion,
              estimated_time: item?.estimated_time,
              veg_type: item?.veg_type,
              // category: item?.category,
              // subCategory: item?.subCategory,
              type: item?.type,
              images: item?.images,
              quantity: 1,
            },
          ];
        }

        localStorage.setItem('cart', JSON.stringify(updatedCart));

        return updatedCart;
      });
    }
  };

  const handleAdd = (data: any) => {
    if (data) {
      const portions = [
        data.is_full_portion,
        data.is_half_portion,
        data.is_quarter_portion,
      ]
      const truePortionCount = portions.filter(Boolean).length

      if (truePortionCount > 1) {
        openModal('portionSelection')
        setSelectedItem(data)
        setSelectedPortion(
          data.is_full_portion
            ? 'full'
            : data.is_half_portion
              ? 'half'
              : 'quarter'
        )
        return false
      }
    }
    handleItemCountChange(data, 'decrement')
  }

  const renderModal = (): JSX.Element | null => {

    if (!isModalOpen) return null

    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: '130px',
          bottom: (itemCount > 0) ? '70px' : '0px',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'

        }}
      >
        <div
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: 20,
            borderRadius: 2,
            position: 'relative',
            width: '100%',
            height: "100%",
            maxWidth: '425px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <button
            onClick={closeModal}
            style={{
              position: 'absolute',
              top: 10,
              right: 20,
              background: '#fff',
              borderRadius: '50%',
              border: '1px solid #dedede',
              padding: 2,
              fontSize: '20px',
              color: '#000',
            }}
          >
            <FaTimes />
          </button>

          {activeModal === 'portionSelection' && (

            <div style={{ marginTop: '15%', borderRadius: 10, border: "1px solid #dedede", padding: "10px", backgroundColor: '#fff', }}>
              <h4 style={{ textAlign: 'left', fontWeight: 500, marginBottom: 20, marginLeft: 18, fontSize: "16px" }}>
                Portion
              </h4>

              {selectedItem?.is_full_portion && (
                <div
                  className='container row-center-space-between'
                  style={{ marginBottom: 21 }}
                >
                  <span
                    style={{
                      fontSize: 14,
                      fontFamily: 'Poppins',
                    }}
                  >
                    Full
                  </span>

                  <div style={{ display: 'flex', gap: 20 }}>
                    <span style={{ fontFamily: "Poppins", fontSize: 14, }}> {currency ? currency : currencySymbol} {Number(selectedItem?.full_price).toFixed(2)} </span>
                    <label style={{ display: 'flex', alignItems: 'center', }}>
                      <input
                        type="radio"
                        name="portion"
                        value="full"
                        checked={selectedPortion === 'full'}
                        onChange={() => setSelectedPortion('full')}
                        style={{
                          accentColor: '#f9791d',
                        }}
                      />
                    </label>
                  </div>
                </div>
              )}

              {selectedItem?.is_half_portion && (
                <div
                  className='container row-center-space-between'
                  style={{ marginBottom: 21 }}
                >
                  <span
                    style={{
                      fontSize: 14,
                      fontFamily: 'Poppins',
                    }}
                  >
                    Half
                  </span>

                  <div style={{ display: 'flex', gap: 20 }}>
                    <span style={{ fontFamily: "Poppins", fontSize: 14, }}>  {currency ? currency : currencySymbol} {Number(selectedItem?.half_price).toFixed(2)} </span>
                    <label style={{ display: 'flex', alignItems: 'center', }}>
                      <input
                        type="radio"
                        name="portion"
                        value="half"
                        checked={selectedPortion === 'half'}
                        onChange={() => setSelectedPortion('half')}
                        style={{
                          accentColor: '#f9791d',
                        }}
                      />
                    </label>
                  </div>
                </div>
              )}

              {selectedItem?.is_quarter_portion && (
                <div
                  className='container row-center-space-between'
                  style={{ marginBottom: 21 }}
                >
                  <span
                    style={{
                      fontSize: 14,
                      fontFamily: 'Poppins',
                    }}
                  >
                    Quarter
                  </span>

                  <div style={{ display: 'flex', gap: 20 }}>
                    <span style={{ fontFamily: 'Poppins', fontSize: 14 }}>
                      {currency ? currency : currencySymbol} {Number(selectedItem?.quarter_price).toFixed(2)}
                    </span>

                    <label style={{ display: 'flex', alignItems: 'center' }}>
                      <input
                        type="radio"
                        name="portion"
                        value="quarter"
                        checked={selectedPortion === 'quarter'}
                        onChange={() => setSelectedPortion('quarter')}
                        style={{
                          accentColor: '#f9791d',
                        }}
                      />
                    </label>
                  </div>
                </div>
              )}

            </div>
          )}

          <div style={{ textAlign: 'center', marginBottom: 25, }}>
            <components.Button
              text="Add Item"
              variant='inverse'
              onClick={() => handleAddCart()}
            />
          </div>

        </div>
      </div>
    )
  }

  const renderDetailModal = (): JSX.Element | null => {
    if (!detailModalOpen) return null

    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: '130px',
          bottom: (itemCount > 0) ? '70px' : '0px',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'

        }}
      >
        <div
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: 20,
            borderRadius: 2,
            position: 'relative',
            width: '100%',
            height: "100%",
            maxWidth: '425px'
          }}
        >
          <button
            onClick={closeDetailModal}
            style={{
              position: 'absolute',
              top: 10,
              right: 20,
              background: '#fff',
              borderRadius: '50%',
              border: '1px solid #dedede',
              padding: 2,
              fontSize: '20px',
              color: '#000',
            }}
          >
            <FaTimes />
          </button>

          {activeModal === 'detail' && selectedItem && (
            <div style={{ height: '100%', overflowY: 'auto' }}>

              <div style={{ marginTop: '7%', borderRadius: 10 }}>

                <Gallery
                  items={galleryImages}
                  thumbnailPosition="bottom"
                  showThumbnails={true}
                  showFullscreenButton={false}
                  showPlayButton={false}
                  autoPlay={false}
                  onThumbnailClick={(event: React.MouseEvent, index: number) => handleThumbnailClick(selectedItem?.images[index])}
                />
              </div>

              <div style={{ marginTop: 30, marginBottom: 20 }}>
                <p
                  style={{
                    fontSize: 12,
                    fontFamily: 'Poppins',
                    lineHeight: 1.5,
                    WebkitLineClamp: 5,
                    WebkitBoxOrient: 'vertical',
                  }}
                >
                  {selectedItem.description}
                </p>
              </div>
            </div>
          )}

        </div>
      </div>
    )
  }

  const IsCartAdded = (id: string) => {
    const result = cart.filter(c => c.id === id)
    if (result && result.length > 0) {
      return true
    }
    return false
  }

  const getItemQuantity = (id: string) => {
    const result: any = cart.filter(c => c.id === id)
    if (result && result.length > 0) {
      return result[0].quantity
    }
    return false
  }

  const renderContent = (): JSX.Element => {

    const smallScreen = window.innerWidth === 320 && window.innerHeight === 568;

    const smallScreenTwo = window.innerWidth === 360 && window.innerHeight === 640;

    const smallScreenThree = window.innerWidth === 375 && window.innerHeight === 667;

    const handleNavigation = (direction: 'left' | 'right') => {
      setCurrentSection((prevSection) => {
        if (direction === 'left') {
          return prevSection === 0 ? menus.length - 1 : prevSection - 1;
        } else {
          return prevSection === menus.length - 1 ? 0 : prevSection + 1;
        }
      });
    };

    const prevTitle = currentSection === 0 ? menus[menus.length - 1]?.name : menus[currentSection - 1]?.name
    const nextTitle = currentSection === menus.length - 1 ? menus[0]?.name : menus[currentSection + 1]?.name


    return (
      <main className="scrollable" style={{ overflowY: activeModal === 'portionSelection' || activeModal === 'detail' ? 'hidden' : 'auto', height: '100%' }}>
        <div
          style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div className="container"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              background: "#f2f4f4",
              paddingBlock: "20px",
              position: 'absolute',
              top: '69px',
              zIndex: 1000

            }}
          >
            <button
              onClick={() => handleNavigation('left')}
              style={{
                position: 'absolute',
                left: '10px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  width: 0,
                  height: 0,
                  borderTop: '15px solid transparent',
                  borderBottom: '15px solid transparent',
                  borderRight: '20px solid #0c6a69',
                }}
              />
            </button>

            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
              <div
                style={{
                  textAlign: 'center',
                  opacity: 0.1,
                  transform: 'translateX(10%)',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: 60

                }}
              >
                <p style={{ fontWeight: 600, fontSize: 13, fontFamily: "Poppins" }}>{prevTitle}</p>
              </div>

              <div className='' style={{ textAlign: 'center', height: '100%' }}>
                <h5
                  style={{
                    fontWeight: 800,
                    textTransform: 'capitalize',
                    color: '#000',
                    textWrap: 'nowrap',
                    height: '20%',
                    fontSize: smallScreen ? 14 : 16,
                    paddingInline: smallScreen ? 10 : 20,
                  }}
                >
                  {menus[currentSection]?.name || "No Menus Found"}
                </h5>
              </div>
              <div
                style={{
                  textAlign: 'center',
                  opacity: 0.1,
                  transform: 'translateX(-10%)',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: 60
                }}
              >
                <p style={{ fontWeight: 600, fontSize: 13, fontFamily: "Poppins" }}>{nextTitle}</p>
              </div>
            </div>

            <button
              onClick={() => handleNavigation('right')}
              style={{
                position: 'absolute',
                right: '10px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  width: 0,
                  height: 0,
                  borderTop: '15px solid transparent',
                  borderBottom: '15px solid transparent',
                  borderLeft: '20px solid #0c6a69',
                }}
              />
            </button>
          </div>

          <div className="content" style={{ marginTop: smallScreen ? '25%' : "20%", marginBottom: itemCount > 0 ? '25%' : '5%' }}>
            {(isLoading) ? <div style={{ marginTop: '7rem' }}>
              <BeatLoader />
            </div> : <>
              <div>
                {filteredItems && filteredItems.length > 0 ? (
                  <>
                    {filteredItems.map((item: any) => (
                      <div className='container' style={{ borderBottom: '2px solid #d3d3d3' }} key={item.id}>
                        <div
                          style={{
                            gap: 6,
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            marginTop: 16,
                          }}
                        >
                          <div>
                            <h5
                              style={{
                                textAlign: 'left',
                                marginBottom: 2,
                                textTransform: 'capitalize',
                                fontWeight: 500,
                                fontSize: smallScreen ? '13px' : '14px'
                              }}
                            >
                              {item.name}
                            </h5>
                            <p
                              className='t18'
                              style={{
                                textAlign: 'left',
                                marginBottom: 10,
                                lineHeight: 1.5,
                                fontSize: smallScreen ? '11px' : '12px'
                              }}
                            >
                              {item.description.length > 58 ? item.description.substring(0, 58) + '...' : item.description}
                              <span
                                style={{
                                  textTransform: 'uppercase',
                                  fontWeight: 700,
                                  fontSize: smallScreen ? '11px' : '12px',
                                  cursor: 'pointer',
                                }}
                                onClick={() => handleDetail(item)}
                              >
                                &nbsp;more
                              </span>
                            </p>


                            {IsCartAdded(item.id) ? (
                              <div
                                className='container'
                                style={{ marginBottom: 21, paddingLeft: 0 }}
                              >
                                <div
                                  style={{
                                    padding: '10px',
                                    borderRadius: 10,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '90%',
                                    backgroundColor: '#252525',
                                    marginRight: 10,
                                    height: '50px',
                                  }}
                                >
                                  <button
                                    onClick={() => handleItemCountChange(item, 'decrement')}
                                  >
                                    <FiMinus color='#fff' size={18} style={{ marginLeft: 7 }} />
                                  </button>
                                  <span
                                    style={{
                                      marginTop: 2,
                                      fontSize: 14,
                                      color: 'white',
                                      fontFamily: 'Poppins',
                                    }}
                                  >
                                    {getItemQuantity(item.id)}
                                  </span>
                                  <button
                                    onClick={() => handleItemCountChange(item, 'increment')}
                                  >
                                    <FiPlus color='#fff' size={18} />
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div style={{ position: 'relative', marginBottom: 20, marginRight: 30 }}>
                                <div style={{ fontWeight: 500 }}>
                                  <components.Button
                                    text='ADD'
                                    colorScheme='secondary'
                                    onClick={() => handleAdd(item)}
                                  />
                                </div>
                                <span
                                  style={{
                                    position: 'absolute',
                                    top: 13,
                                    right: 13,
                                    transform: 'translate(50%, -50%)',
                                    color: '#000',
                                    width: 16,
                                    height: 16,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 22,
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => handleAdd(item)}
                                >
                                  +
                                </span>
                              </div>
                            )}

                          </div>

                          <div style={{ position: 'relative' }}>
                            <img
                              src={item.images && item.images.length > 0 ? `${Config.MEDIA_URL}${item.images[0]}?alt=media` : food}
                              alt=''
                              style={{
                                width: '100%',
                                height: '75%',
                                backgroundColor: '#d6d1ce',
                              }}
                              onClick={() => handleAdd(item)}
                            />
                            {/*  <img
                              src={settings}
                              alt='settings'
                              style={{
                                position: 'absolute',
                                top: '7px',
                                right: '7px',
                                width: '25px',
                                height: '25px',
                              }}
                            /> */}
                            <img
                              src={item.veg_type === 'Veg' ? green : red}
                              alt={item.veg_type === 'Veg' ? 'green' : 'red'}
                              style={{
                                position: 'absolute',
                                top: '7px',
                                left: '7px',
                                width: '17px',
                                height: '17px',
                              }}
                            />
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '20px',
                                padding: '4px 34px',
                                left: '49%',
                                transform: 'translateX(-49%)',
                                backgroundColor: '#d6d1ce',
                                borderRadius: '10px',
                                fontSize: '12px',
                                fontWeight: '500',
                                fontFamily: 'Poppins',
                                color: '#000000',
                                border: '2px solid #d6d1ce',
                                borderTopLeftRadius: 0,
                                borderTopRightRadius: 0,
                                borderBottomLeftRadius: 10,
                                borderBottomRightRadius: 10,
                                width: '100%',
                                textWrap: 'nowrap',
                                textAlign: 'center',
                              }}
                            >
                              {currency ? currency : currencySymbol} {(item.is_full_portion && !isNaN(Number(item.full_price))) ? Number(item.full_price).toFixed(2) : (item.is_half_portion && !isNaN(Number(item.half_price))) ? Number(item.half_price).toFixed(2) : (item.is_quarter_portion && !isNaN(Number(item.quarter_price))) ? Number(item.quarter_price).toFixed(2) : '0.00'} {taxName && `+ ${taxName}`}

                            </div>
                          </div>

                        </div>
                      </div>
                    ))
                    }
                  </>
                ) : (
                  <>
                    <div className='container'>
                      <p
                        className='t18'
                        style={{ textAlign: 'center', marginTop: 50, marginBottom: 30, fontSize: 16, opacity: 0.25 }}
                      >
                        Oops! It looks like our {menus[currentSection]?.name} are all empty right now. Stay tuned, something delicious is coming soon!
                      </p>
                    </div>
                  </>
                )}
              </div>
            </>
            }
          </div>

        </div>

        {(!isMenuModalOpen) ? (
          <img
            src={menu}
            alt="menu"
            style={{
              position: 'absolute',
              bottom: itemCount > 0 || smallScreen || smallScreenTwo ? '80px' : '30px',
              right: '5px',
              width: '45px',
              height: '45px',
              zIndex: 1000,
              cursor: "pointer"
            }}
            onClick={handleMenuClick}
          />
        ) : (
          <img
            src={close}
            alt="close"
            style={{
              position: 'absolute',
              bottom: itemCount > 0 || smallScreen || smallScreenTwo ? '80px' : '30px',
              right: '5px',
              width: '45px',
              height: '45px',
              zIndex: 1000,
              cursor: "pointer"
            }}
            onClick={handleMenuClose}
          />
        )
        }


        {isMenuModalOpen && (
          <div
            style={{
              position: 'fixed',
              top: smallScreen || smallScreenTwo
                ? (menus.length < 5 ? '10%' : '0')
                : smallScreenThree
                  ? (menus.length < 5 ? '21%' : '10%')
                  : (menus.length < 5 ? '27%' : '20%'),
              right: 20,
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'end',
              alignItems: 'center',
              zIndex: 2000
            }}
            onClick={handleMenuClose}
          >
            <div
              style={{
                width: smallScreen ? '200px' : '220px',
                backgroundColor: '#000',
                color: '#fff',
                borderRadius: '15px',
                padding: '10px',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                maxHeight: menus.length > 5 ? '300px' : 'auto',
                overflowY: menus.length > 5 ? 'auto' : 'visible',
                textAlign: 'center'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {menus.length > 1 ? (
                <ul
                  style={{
                    listStyleType: 'none',
                    padding: 0,
                    margin: 0,
                  }}
                >
                  {menus.map((item: any, index: any) => (
                    <li
                      key={item.id}
                      style={{
                        padding: smallScreen ? '8px 0' : '10px 0',
                        borderBottom: '1px solid #3D3D3D',
                        textAlign: 'center',
                        cursor: 'pointer',
                        fontFamily: "Poppins",
                        fontSize: smallScreen ? 12 : 14
                      }}
                      onClick={() => {
                        setCurrentSection(index)
                        handleMenuClose()
                      }}
                    >
                      {item.name}
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={{ fontFamily: "Poppins", fontSize: smallScreen ? 12 : 14 }}>
                  No Menus Found
                </p>
              )}
            </div>
          </div>
        )}


        {(itemCount > 0) &&
          <div className='container' style={{
            backgroundColor: "#000",
            height: 70,
            display: 'flex',
            alignItems: 'center',
            justifyContent: "space-around",
            position: "absolute",
            bottom: 0

          }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <p
                className='t18'
                style={{
                  textAlign: 'left', color: "#fff", display: "flex",
                  alignItems: "center",
                  marginRight: 5
                }}
              >
                {itemCount} {(itemCount > 1) ? 'Items' : 'Item'} Added
              </p>
              <FiArrowRightCircle size={18} color="#fff" />
            </div>
            <div >
              <components.Button
                text='Place Order'
                colorScheme='orange'
                to='/orders'
                containerStyle={{
                  padding: '5px 15px',
                  height: '42px',
                  fontSize: '12px',
                  width: '100%'
                }}
              />
            </div>
          </div>
        }
      </main>
    );
  };

  const renderInvalidContent = (): JSX.Element => {
    return (
      <main
        className='scrollable center'
        style={{ zIndex: 1 }}
      >
        <div className='container' style={{ display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column", opacity: 0.9 }}>
          <div>
            <img
              src={food}
              alt=""
              style={{
                width: '200px',
                maxWidth: '400px',
                height: '200px',
                margin: 'auto',
                display: 'block',
              }}
            />
          </div>
          <p className='t18' style={{ textAlign: 'center', fontSize: 18, fontWeight: 800 }}>
            Invalid Restaurant!
          </p>
        </div>
      </main>
    );
  };

  const renderUnavailableContent = () => (
    <main className='scrollable center'>
      <div className='container' style={{ display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column", opacity: 0.9 }}>
        <div>
          <img
            src={food}
            alt=""
            style={{
              width: '200px',
              maxWidth: '400px',
              height: '200px',
              margin: 'auto',
              display: 'block',
            }}
          />
        </div>
        <p className='t18' style={{ textAlign: 'center', fontSize: 18, fontWeight: 800 }}>
          Service unavailable.
        </p>
        <p className='t18' style={{ textAlign: 'center', fontSize: 18, fontWeight: 800 }}>
          Please contact the restaurant.
        </p>
      </div>
    </main>
  );

  return (
    <>
      {(isLoading || isFetching) ? (
        <main className='scrollable center'>
          <div className='container' style={{ height: '100%', margin: 'auto' }}>
            <div style={{ marginTop: 150, textAlign: "center" }}>
              <BeatLoader />
            </div>
          </div>
        </main>
      ) : (
        <>
          {isRestaurant ? (
            serviceAvailable ? (
              <>
                {renderHeader()}
                {renderContent()}
                {renderModal()}
                {renderDetailModal()}
              </>
            ) : (
              renderUnavailableContent()
            )
          ) : (
            renderInvalidContent()
          )}
        </>
      )}
    </>
  );
}
